<template>
  <v-fab-transition>
    <v-btn name="btn_back_to_top" id="btn_back_to_top" fab="fab" small fixed bottom right color="primary" v-show="fab" @click="toTop">
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
  </v-fab-transition>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  data: () => ({
    fab: false
  }),

   events: {
    [HANDLERS.BACK_TO_TOP]: 'toTop',
  },

  methods: {
    onScroll() {
      if (typeof window === undefined) return;

      const top = window.pageYOffset || document.documentElement.offsetTop || 0;

      this.fab = top > 300;
    },

    toTop() {
      this.$vuetify.goTo(0);
    }
  },

  created() {
    window.addEventListener('scroll', this.onScroll);
  },

  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  }
};
</script>
